export default function H2Secondary({ children, design = '', style }) {
	return (
		<p className={` H2Secondary ${design}`} style={style}>
			{children}
		</p>
	);
}
